// tslint:disable:max-line-length
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('UI');

export const pageIsScrolling = actionCreator<boolean>('PAGE_IS_SCROLLING');
export const toggleLicenseBarVisibility = actionCreator<boolean>('TOGGLE_LICENSE_BAR_VISIBILITY');
export const setLicenseBarHeight = actionCreator<number>('SET_LICENSE_BAR_HEIGHT');
export const toggleLogInFormVisibility = actionCreator<boolean>('TOGGLE_LOG_IN_FORM_VISIBILITY');
export const toggleHeaderVisibility = actionCreator<boolean>('TOGGLE_TOP_BAR_VISIBILITY');
export const toggleTrackDetailsVisibility = actionCreator<boolean>('TOGGLE_TRACK_DETAILS_VISIBILITY');
export const toggleAddToProjectVisibility = actionCreator<boolean>('TOGGLE_ADD_TO_PROJECT_VISIBILITY');
export const toggleSignUpFormVisibility = actionCreator<boolean>('TOGGLE_SIGN_UP_FORM_VISIBILITY');
export const togglePlayerTermListVisibility = actionCreator<boolean>('TOGGLE_PLAYER_TERM_LIST_VISIBILITY');
export const setHeaderType = actionCreator<{ type: HeaderType }>('SET_HEADER_TYPE');
export const setHeaderActions = actionCreator<{ actions: JSX.Element[] }>('SET_HEADER_ACTIONS');
export const showAddTrackToProjectForm = actionCreator<IShowAddToProjectFormActionPayload>('SHOW_ADD_TO_PROJECT_FORM');
export const showTrackDetails = actionCreator<IShowTrackDetailsActionPayload>('SHOW_TRACK_DETAILS');
export const showSignUpForm = actionCreator<IShowSignUpFormActionPayload>('SHOW_SIGN_UP_FORM');
export const showDownloadAgreementModal = actionCreator<IShowDownloadAgreementModalActionPayload>('SHOW_DOWNLOAD_AGREEMENT_MODAL');
export const clearUIState = actionCreator<keyof IUIState>('CLEAR_UI_STATE');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/ui.ts